import _toConsumableArray from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { utils } from "./utils.js";

/**
 * Poly Bezier
 * @param {[type]} curves [description]
 */
var PolyBezier = /*#__PURE__*/function () {
  function PolyBezier(curves) {
    _classCallCheck(this, PolyBezier);
    this.curves = [];
    this._3d = false;
    if (!!curves) {
      this.curves = curves;
      this._3d = this.curves[0]._3d;
    }
  }
  _createClass(PolyBezier, [{
    key: "valueOf",
    value: function valueOf() {
      return this.toString();
    }
  }, {
    key: "toString",
    value: function toString() {
      return "[" + this.curves.map(function (curve) {
        return utils.pointsToString(curve.points);
      }).join(", ") + "]";
    }
  }, {
    key: "addCurve",
    value: function addCurve(curve) {
      this.curves.push(curve);
      this._3d = this._3d || curve._3d;
    }
  }, {
    key: "length",
    value: function length() {
      return this.curves.map(function (v) {
        return v.length();
      }).reduce(function (a, b) {
        return a + b;
      });
    }
  }, {
    key: "curve",
    value: function curve(idx) {
      return this.curves[idx];
    }
  }, {
    key: "bbox",
    value: function bbox() {
      var c = this.curves;
      var bbox = c[0].bbox();
      for (var i = 1; i < c.length; i++) {
        utils.expandbox(bbox, c[i].bbox());
      }
      return bbox;
    }
  }, {
    key: "offset",
    value: function offset(d) {
      var offset = [];
      this.curves.forEach(function (v) {
        offset.push.apply(offset, _toConsumableArray(v.offset(d)));
      });
      return new PolyBezier(offset);
    }
  }]);
  return PolyBezier;
}();
export { PolyBezier };